import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Modal } from 'react-bootstrap'

import TopicCheckboxItem from '../TopicCheckboxItem'

import { defaultTargetScore } from '../../../lib/legacy/legacyActivityBuilder'

import base from 'Styles/base.css'
import style from './style.css'

import closeIcon from 'Assets/x-icon-gray.svg'

export default class EditTopicsModal extends Component {
  constructor (props) {
    super(props)

    this.onEnabledChange = this.onEnabledChange.bind(this)
    this.onSaveChanges = this.onSaveChanges.bind(this)
    this.onProceed = this.onProceed.bind(this)

    this.state = {
      enabledTopics: props.enabledTopics,
      scoreTarget: props.scoreTarget,
      studentActivity: props.studentActivity
    }
  }

  onProceed () {
    this.setState({
      studentActivity: false
    })
  }

  onSaveChanges () {
    this.props.onSaveChanges(this.state.enabledTopics)
  }

  onEnabledChange (topic) {
    const enabledTopics = this.state.enabledTopics.slice()
    const index = enabledTopics.findIndex(t => t.topicId === topic.topicId)
    index >= 0
      ? enabledTopics.splice(index, 1)
      : enabledTopics.push(topic)

    // defaultTargetScore only expects an object with topics and questions properties
    // so there is no need to pass it the entire LC object from redux
    const scoreTarget = defaultTargetScore({ topics: enabledTopics, questions: this.props.questions })
    this.setState({
      enabledTopics,
      scoreTarget
    })
  }

  renderTopics () {
    return this.props.allTopics.map((topic, index) => {
      const enabled = this.state.enabledTopics.findIndex(t => t.topicId === topic.topicId) >= 0
      return (
        <TopicCheckboxItem
          key={topic.label}
          index={index}
          topic={topic}
          enabled={enabled}
          onEnabledChange={this.onEnabledChange}
          data-test-id="editTopicRenderTopicsCheckBox"
        />
      )
    })
  }

  renderWarning () {
    if (!this.state.enabledTopics.length) {
      return (
        <h5 className={style.warning} data-test-id="editTopicModalAddQuestionsWarning">
          You must have at least one topic in your quiz.
        </h5>
      )
    } else if (this.state.enabledTopics.length === 1) {
      return (
        <h5 className={style.warning} data-test-id="editTopicModalAddMoreQuestionsWarning">
          Note: Quizzes with only one topic tend to be small, and
          your students may experience repeating questions.
        </h5>
      )
    }
  }

  renderEditModal () {
    const topicLength = this.state.enabledTopics.length
    const divInline = {
      display: 'inline-block'
    }
    return (

      <Modal show={true} className={style.modalWrapper}>
        <div className={style.containerModal}>
          <Modal.Header className={style.topicsHeader}>
            <button
              data-test-id="closeEditTopics"
              aria-label="Close Edit Topics"
              className={classnames(style.closeEditTopics, style.hideModal)}
              onClick={this.props.onCancelEditTopics}
              tabIndex="0"
            >
              <object
                data={closeIcon} type="image/svg+xml"
                className={base.svgIcon}
                tabIndex="-1"
              />
            </button>
            <Modal.Title className={style.title}>
              Edit Topics
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={style.text} tabIndex="0">
            Hide topics that you don’t want students to get questions on.
            Note that you’ll need to keep at least two topics.
            <div className={style.targetScoreHeader}>
              Target score: <span
                className={style.score}
                data-test-id="editTopicsTargetScore"
              >{this.state.scoreTarget}</span> pts
              <span className={style.includeText}>Include?</span>
            </div>
            {this.renderTopics()}
          </Modal.Body>
          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            <div style={divInline}>
              <div className={style.buttonContainer}>
                <button
                  className={classnames('btn-cdl-main', style.saveButton,
                    topicLength
                      ? (topicLength === 1 ? style.saveButtonWarning : style.saveButtonActive)
                      : style.saveButtonDisabled)
                  }
                  onClick={this.onSaveChanges}
                  disabled={!this.state.enabledTopics.length}
                  data-test-id="editTopicsSaveBtn"
                >
                  Save Changes
                </button>
              </div>
            </div>
            <div style={divInline}>
              <div className={style.buttonContainer}>
                <button
                  className={classnames('btn-cdl-secondary', style.cancelButton)}
                  onClick={this.props.onCancelEditTopics}
                  data-test-id="editTopicsCancelBtn"
                >
                  Cancel
                </button>
              </div>
            </div>
            {this.renderWarning()}
          </Modal.Footer>
        </div>
      </Modal>
    )
  }

  renderActivityWarningModal () {
    return (

      <Modal show={true}>
        <div className={style.containerModal}>
          <Modal.Header className={style.topicsHeader}>
            <button
              data-test-id="closeEditTopics"
              aria-label="Close Edit Topics"
              className={classnames(style.closeEditTarget, style.hideModal)}
              onClick={this.props.onCancelEditTopics}
              tabIndex="0"
            >
              <object
                data={closeIcon} type="image/svg+xml"
                className={base.svgIcon}
                tabIndex="-1"
              />
            </button>
            <Modal.Title className={style.title}>
              Students have begun this activity!
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={style.text} tabIndex="0">
            Changing the number of topics may affect activity completion status for some students,
            and they will need to revisit the activity for their grades to update.
            <span className={style.question}>
              This affects the entire class. Are you sure you want to do this?
            </span>
          </Modal.Body>
          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            <button
              className={classnames('btn-cdl-main', style.proceedButton)}
              onClick={this.onProceed}
            >
              Proceed
            </button>

            <button
              className={classnames('btn-cdl-secondary', style.cancelButton)}
              onClick={this.props.onCancelEditTopics}
            >
              Cancel
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    )
  }

  render () {
    return this.state.studentActivity && !this.props.hideWarningForSampleStudents
      ? this.renderActivityWarningModal()
      : this.renderEditModal()
  }
}

EditTopicsModal.propTypes = {
  scoreTarget: PropTypes.number.isRequired,
  allTopics: PropTypes.array.isRequired,
  enabledTopics: PropTypes.array.isRequired,
  questions: PropTypes.array.isRequired,
  onSaveChanges: PropTypes.func.isRequired,
  onCancelEditTopics: PropTypes.func.isRequired,
  studentActivity: PropTypes.bool.isRequired,
  hideWarningForSampleStudents: PropTypes.bool.isRequired
}
